import React, { Component } from 'react';
import axios from 'axios'
import { Button, Card, Table } from 'react-bootstrap'
import { connect } from 'react-redux';
import { refreshJobInDraft } from '../actions/jobDraft';

class FilamentSelection extends Component {
    state = {
        filamentsFormatted: [],
    }

    componentDidMount() {
        this.getFilaments()
    }

    getFilaments = () => {
        axios.get('/api/filament/get-all').then((resp) => {
            let filamentsFormatted = this.state.filamentsFormatted
            resp.data.filaments.forEach(filament => {
                filamentsFormatted.push({ 'pricePerGram': filament.pricePerGram, 'name': filament.name, 'type': filament.type, 'stockInGrams': filament.stockInGrams, '_id': filament._id })
            })
            this.setState({ filamentsFormatted: filamentsFormatted, })
        })
    }

    selectFilament = (id) => {
        this.setState({ selected: id })
        axios.post("/api/jobs/set/filament/by/id", { job: this.props.jobDraft._id, filament: id }).then(() => {
            this.props.refreshJobInDraft(this.props.jobDraft._id)
        })
    }

    render() {
        let filaments = []
        this.state.filamentsFormatted.forEach((filament) => {
            filaments.push(
                <tr key={filament._id}>
                    <td ><input placeholder={filament.name}></input></td>
                    <td ><input placeholder={filament.type}></input></td>
                    <td ><input type="number" placeholder={filament.pricePerGram} /></td>

                    <td>
                        <Button type='submit' onClick={() => this.selectFilament(filament._id)}>
                            Select
                        </Button>
                    </td>
                </tr>
            )
        })
        let selected = {}
        if (this.props.jobDraft.filament) {
            this.state.filamentsFormatted.forEach(filament => {
                if (filament._id == this.props.jobDraft.filament) {
                    selected = filament
                }
            })
        }
        let darkmode = this.props.user ? this.props.user.darkmode : true

        return (
            <div>
                {this.props.jobDraft.filament ?
                    <div style={{ margin: '30px' }}>
                        <h2 style={{ textAlign: 'center' }}>
                            Filament
                        </h2>
                        <div style={{ 'margin': '0px' }} >
                            <p>Name: {selected.name}</p>
                            <p>Type: {selected.type}</p>
                            <p> pricePerGram: {selected.pricePerGram}</p>
                            <Button style={{maxWidth: "200px"}} type='submit' onClick={() => this.selectFilament(null)}> Change Selection </Button>
                        </div>

                    </div>
                    :
                    <div style={{ margin: '30px' }}>
                        <h2 style={{ textAlign: 'center' }}>
                            Filament
                        </h2>
                        <Table style={{ 'margin': '0px' }} bordered>
                            <thead className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} >
                                <tr>
                                    <th>name</th>
                                    <th>type</th>
                                    <th>pricePerGram</th>
                                    <th>Select</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filaments}
                            </tbody>
                        </Table>
                    </div>
                }

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        jobDraft: state.jobDraft
    }
}
function mapDispatchToProps(dispatch) {
    return {
        refreshJobInDraft: (jobId) => dispatch(refreshJobInDraft(jobId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilamentSelection);